import { LoaderSmall } from "../../LoaderSmall/LoaderSmall";
import styles from '../Filter.module.scss';

export const FilterLoader = () => {
  return (
    <div className={styles.loaderContainer}>
      <LoaderSmall />
    </div>
  )
};
